// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4389":"df726126","5290":"905685dd","9574":"df726126","9815":"df726126","9894":"df726126"}[chunkId] + ".chunk.css";
};